(() => {
  const ATTRIBUTE_NAME = 'U.S. Consignee / Importer EIN';
  const EMPTY_MESSAGE =
    'A U.S. Consignee / Importer EIN is required for all orders shipped to the United States.';
  const FORMAT_MESSAGE = 'Please enter a valid 9-digit U.S. EIN, for example 12-3456789.';
  const SAVE_MESSAGE = 'We could not save the EIN. Please try again before continuing to checkout.';
  let saveTimer;

  const formatEin = (value) => {
    const digits = String(value || '').replace(/\D/g, '').slice(0, 9);
    return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
  };

  const getElements = () => {
    const container = document.querySelector('[data-apx-ein]');
    return {
      container,
      input: container?.querySelector('#ApxImporterEin'),
      error: container?.querySelector('#ApxImporterEinError'),
    };
  };

  const showError = (input, error, message = '') => {
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    error.textContent = message;
    error.hidden = !message;
  };

  const validate = ({ container, input, error }) => {
    if (!container || !input || !error) return false;

    const digits = input.value.replace(/\D/g, '');
    const requiredForMarket = container.dataset.requiredForMarket === 'true';

    if (!digits && requiredForMarket) {
      showError(input, error, EMPTY_MESSAGE);
      return false;
    }

    if (digits && digits.length !== 9) {
      showError(input, error, FORMAT_MESSAGE);
      return false;
    }

    showError(input, error);
    return true;
  };

  const save = async ({ container, input, error }) => {
    if (!container || !input || !error) return false;

    const value = formatEin(input.value);
    const updateUrl = container.dataset.cartUpdateUrl || '/cart/update.js';
    input.value = value;
    container.classList.add('is-saving');

    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ attributes: { [ATTRIBUTE_NAME]: value } }),
      });

      if (!response.ok) throw new Error('Cart update failed');
      return true;
    } catch (saveError) {
      showError(input, error, SAVE_MESSAGE);
      return false;
    } finally {
      container.classList.remove('is-saving');
    }
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches('#ApxImporterEin')) return;

    const elements = getElements();
    elements.input.value = formatEin(elements.input.value);
    showError(elements.input, elements.error);
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(() => {
      const currentElements = getElements();
      if (validate(currentElements)) save(currentElements);
    }, 600);
  });

  document.addEventListener('focusout', (event) => {
    if (!event.target.matches('#ApxImporterEin')) return;

    window.clearTimeout(saveTimer);
    const elements = getElements();
    if (validate(elements)) save(elements);
  });

  document.addEventListener('click', async (event) => {
    const checkoutButton = event.target.closest('#checkout[name="checkout"]');
    if (!checkoutButton) return;

    const elements = getElements();
    if (!elements.container || !elements.input || !elements.error) return;

    event.preventDefault();
    window.clearTimeout(saveTimer);

    if (!validate(elements)) {
      elements.input?.focus();
      return;
    }

    checkoutButton.disabled = true;
    checkoutButton.setAttribute('aria-busy', 'true');

    const saved = await save(elements);
    if (saved) {
      window.location.assign(elements.container.dataset.checkoutUrl || '/checkout');
      return;
    }

    checkoutButton.disabled = false;
    checkoutButton.removeAttribute('aria-busy');
    elements.input?.focus();
  });
})();
